import Icon from '@/components/ui/AppIcon';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    apartments: [
      { label: 'Luxos Luxury', href: '/apartment-categories' },
      { label: 'Classica Comfort', href: '/apartment-categories' },
      { label: 'Amenities', href: '/amenities-and-services' }
    ],
    company: [
      { label: 'About Us', href: '/about-us' },
      { label: 'Location Guide', href: '/location-guide' }
    ],
    support: [
      { label: 'Book Now', href: 'https://bookingengine.stayflexi.com/?hotel_id=33526' },
      { label: 'Contact Us', href: '/contact-us' },
      { label: 'FAQs', href: '/faq' }
    ]
  };

  const socialLinks = [
    { name: 'Facebook', icon: 'ShareIcon', href: '#' },
    { name: 'Instagram', icon: 'CameraIcon', href: '#' },
    { name: 'LinkedIn', icon: 'BriefcaseIcon', href: '#' },
    { name: 'Twitter', icon: 'ChatBubbleLeftIcon', href: '#' }
  ];

  return (
    <footer className="bg-primary text-white">
      <div className="max-w-7xl mx-auto px-4 py-12">

        <div className="border-t border-white/20 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="text-white/80 text-sm">
              © {currentYear} Proximus Serviced Apartments. All rights reserved.
            </div>
            
            <div className="flex items-center space-x-4">
              {socialLinks.map((social) => (
                <a
                  key={social.name}
                  href={social.href}
                  className="w-10 h-10 bg-white/10 hover:bg-accent rounded-full flex items-center justify-center transition-all duration-300 hover:scale-110"
                  aria-label={social.name}
                >
                  <Icon name={social.icon as any} size={18} />
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}